import { render, staticRenderFns } from "./ExportButton.vue?vue&type=template&id=22394dc1&scoped=true&"
import script from "./ExportButton.vue?vue&type=script&lang=ts&"
export * from "./ExportButton.vue?vue&type=script&lang=ts&"
import style0 from "./ExportButton.vue?vue&type=style&index=0&id=22394dc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22394dc1",
  null
  
)

export default component.exports